import * as React from 'react';
import * as styles from '../support.module.scss';
import SupportTicket from '../../../models/supportTicket';

interface Props {
  ticket: SupportTicket;
  handleModal: (isOpen: boolean, ticket: SupportTicket) => void;
}

/**
 * SupportEntry
 * @function SupportEntry
 */
const SupportEntry = ({ ticket, handleModal }: Props) => {
  const firstRender = React.useRef<boolean>(true);

  React.useEffect(() => {
    if (!firstRender.current) {
      handleModal(true, ticket);
    }
    firstRender.current = false;
  }, [ticket.comments.length]);

  return (
    <tr>
      <td className={styles.typeRow}>{ticket.issueType}</td>
      <td className={styles.refRow} onClick={() => handleModal(true, ticket)}>
        {ticket.issueName}
      </td>
      <td className={styles.summaryRow} title={ticket.summary}>
        {ticket.summary}
      </td>
      <td>{ticket.status}</td>
      <td className={styles.summaryRow} title={ticket.reporter}>
        {ticket.reporter}
      </td>
      <td>{ticket.organizationName}</td>
      <td>{ticket.createdTime}</td>
      <td>{ticket.updatedTime}</td>
    </tr>
  );
};

export default SupportEntry;
